import PopupManager from '../managers/PopupManager';
import $ from 'jquery';
import VideoIframeService from '../services/VideoIframeService';
import { PAUSED_VIDEO, PLAY_VIDEO } from '../constans';
import EventBusService from '../services/EventBusService';

export default class VideoPopup {
    private ANIMATION_TIME = 300;
    private selectors = {
        openPopup: '.js-open-video-popup',
        iframe: '.js-iframe-video',
    };

    private playTimeoutId: NodeJS.Timeout | null = null;
    private $popupContainer: JQuery | null = null;


    constructor(private $holder: JQuery, private popupManager: PopupManager) {
        this.openPopupHandler = this.openPopupHandler.bind(this);
        this.init();
    }

    private init(): void {
        EventBusService.addEventListener(
            EventBusService.CLOSE_POPUP,
            this.stopPlayVideo
        );
        this.$holder.on('click', this.selectors.openPopup, this.openPopupHandler);
    }

    private openPopupHandler(event: Event): void {
        const $target = $(event.currentTarget as HTMLElement);
        const typePopup = ($target.data('type-popup') as string) ?? null;

        if (!typePopup) {
            return;
        }

        this.$popupContainer = this.popupManager.openPopupByType(typePopup);
        this.playVideo();
    }

    private playVideo(): void {

        if (this.playTimeoutId) {
            clearTimeout(this.playTimeoutId);
        }

        this.playTimeoutId = setTimeout(() => {
            if (!this.$popupContainer) {
                return;
            }

            const $iframe = this.$popupContainer.find(this.selectors.iframe);

            $iframe.each((_, iframe) => {
                VideoIframeService.sendMessageToIframe(iframe as HTMLIFrameElement, PLAY_VIDEO);
            })
        }, this.ANIMATION_TIME);

    }

    /**
     * Останавливаем проигрывание видео
     * @private
     */
    private stopPlayVideo(): void {
        if (!this.$popupContainer) {
            return;
        }

        this.$popupContainer.find(this.selectors.iframe).each((_, iframe) => {
            VideoIframeService.sendMessageToIframe(iframe as HTMLIFrameElement, PAUSED_VIDEO);
        })
    }

}
